// extracted by mini-css-extract-plugin
export default {"changeLink":"dW-z","disabled":"eW-z","inline":"fW-z"};